"use strict";

exports.__esModule = true;
exports.generateFormattedColumns = void 0;
var _react = _interopRequireDefault(require("react"));
var _formatColumns = require("../../Core/DataTable/formatColumns");
var _Translator = require("../../Core/Translator");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _PlantStateActivitiesContext = require("../../PlantStateActivities/PlantStateActivitiesContext");
var _TicketTypeListContext = require("../../TicketTypes/TicketTypeListContext");
var _TimeContext = require("../../Time/TimeContext");
var _UserListContext = require("../../User/UserListContext");
var _PlantStateActivities = require("../../PlantStateActivities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var generateFormattedColumns = exports.generateFormattedColumns = function generateFormattedColumns(props) {
  var data = props.data,
    columns = props.columns;
  var time = _react["default"].useContext(_TimeContext.TimeContext);
  var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)(_react["default"].useContext(_PlantStateActivitiesContext.PlantStateActivitiesContext));
  var translator = _react["default"].useContext(_Translator.TranslatorContext);
  var translate = translator.translate;
  var users = _react["default"].useContext(_UserListContext.UserListContext);
  var ticketTypes = _react["default"].useContext(_TicketTypeListContext.TicketTypeListContext);
  var devices = _react["default"].useContext(_DeviceListContext.AllDeviceListContext);
  return (0, _formatColumns.formatColumns)(columns, data, {
    translate: translate,
    time: time,
    devices: devices,
    plantStateActivities: plantStateActivities,
    users: users,
    ticketTypes: ticketTypes
  });
};